import { emit, Event } from '../events';
export var Identity;
(function (Identity) {
    function create() {
        let id = Math.floor(Math.random() * 0x1000000).toString(16);
        return id;
    }
    Identity.create = create;
})(Identity || (Identity = {}));
export var Packet;
(function (Packet) {
    Packet.all = [];
    function define() {
        const id = Packet.all.length;
        Packet.all.push(id);
        return id;
    }
    Packet.define = define;
    function seal(packet, value) {
        if (value === undefined)
            return packet;
        else
            return [packet, value];
    }
    Packet.seal = seal;
    function unseal(raw) {
        var _a, _b;
        if (typeof raw == 'number')
            return [(_a = Packet.all[raw]) !== null && _a !== void 0 ? _a : raw, undefined];
        else {
            let [id, value] = raw;
            return [(_b = Packet.all[id]) !== null && _b !== void 0 ? _b : id, value];
        }
    }
    Packet.unseal = unseal;
})(Packet || (Packet = {}));
export var Dispatch;
(function (Dispatch) {
    function create() {
        let map = new Map();
        return {
            on(message, handler) {
                map.set(message, handler);
            },
            emit(message, value) {
                var _a;
                (_a = map.get(message)) === null || _a === void 0 ? void 0 : _a(value);
            },
        };
    }
    Dispatch.create = create;
})(Dispatch || (Dispatch = {}));
const socket_events = new WeakMap();
function setup_events(socket) {
    let events = new Map();
    socket.addEventListener('message', e => {
        try {
            let [packet, value] = Packet.unseal(JSON.parse(e.data));
            let event = events.get(packet);
            if (event) {
                emit(event, value);
            }
        }
        catch (_a) { }
    });
    return events;
}
export function send(socket, ty, value) {
    let sealed = Packet.seal(ty, value);
    socket.send(JSON.stringify(sealed));
}
export function receive(socket, ty) {
    let map = socket_events.get(socket);
    if (!map)
        socket_events.set(socket, map = setup_events(socket));
    let event = map.get(ty);
    if (!event)
        map.set(ty, event = Event());
    return event;
}
